import $ from 'jquery';

var selectors = {
  filtersWrappper: '[data-filters]',
  underlay: '[data-filters-underlay]',
  filtersHideDesktop: 'data-default-hide',
  filtersToggle: 'data-filters-toggle',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
};

var classes = {
  show: 'filters--visible',
  defaultVisible: 'filters--default-visible',
  hide: 'hidden',
};

var sections = {};

class Filters {
  constructor($filters) {
    this.$container = $filters;
    this.$underlay = $(selectors.underlay, this.$container);
    const triggerKey = $filters.data().filters;
    this.$filtersToggle = this._findButtons(triggerKey);
    this._connectToggle();
    this._onFocusOut();
    if (this._getShowOnLoad()) {
      this._showFilters();
    } else {
      this._hideFilters();
    }
  }
  unload() {
    this.$container.off();
    this.$underlay.off();
    this.$filtersToggle.off();
  }

  _connectToggle() {
    this.$filtersToggle.on(
      'click',
      function(evt) {
        var ariaExpanded = ($(evt.currentTarget).attr('aria-expanded') === 'true');
        if (ariaExpanded) {
          this._hideFilters();
        } else {
          this._showFilters();
        }
      }.bind(this),
    );
  }

  _onFocusOut() {
    this.$container.on(
      'focusout',
      function(evt) {
        if (window.innerWidth >= window.theme.sizes.medium) { return; }

        var childInFocus = ($(evt.currentTarget).has(evt.relatedTarget).length > 0);
        var isVisible = this.$container.hasClass(classes.show);
        var isFocusEnabled = $('body').hasClass('focus-enabled');
        if (isFocusEnabled && isVisible && !childInFocus) {
          this._hideFilters();
        }
      }.bind(this),
    );

    this.$container.on(
      'keyup',
      function(evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
        this._hideFilters();
        this.$filtersToggle.focus();
      }.bind(this),
    );

    this.$underlay.on(
      'click',
      function() {
        this._hideFilters();
      }.bind(this),
    );
  }

  _findButtons(key) {
    // buttons to trigger the filters can be anywhere on the page
    const selector = `[${selectors.filtersToggle}='${key}']`;
    return $(selector);
  }

  _getShowOnLoad() {
    const selector = `[${selectors.filtersHideDesktop}='false']`;
    const showOnDesktop = ($(selector).length > 0);
    const isDesktop = (window.innerWidth >= window.theme.sizes.medium);
    if (showOnDesktop && isDesktop) {
      return true;
    } else {
      return false;
    }
  }

  _showFilters() {
    this.$container.removeClass(classes.hide);
    // animates after display none is removed
    setTimeout(() => {
      this.$filtersToggle.attr('aria-expanded', true);
      this.$filtersToggle.addClass(classes.show);
      this.$container.addClass(classes.show);
      this.$container.find(selectors.focusable).first().focus();
    }, 1);
  }

  _hideFilters() {
    this.$filtersToggle.attr('aria-expanded', false);
    this.$container.removeClass([classes.show, classes.defaultVisible]);
    this.$filtersToggle.removeClass([classes.show, classes.defaultVisible]);
    // adds display none after animations
    setTimeout(() => {
      if (!this.$container.hasClass(classes.show)) {
        this.$container.addClass(classes.hide);
      }
    }, 2000);
  }
}

const collectionFiltersSidebar = {
  onLoad() {
    sections[this.id] = [];
    const wrappers = this.container.querySelectorAll(selectors.filtersWrappper);
    wrappers.forEach(wrapper => {
      const $wrapper = $(wrapper);
      sections[this.id].push(new Filters($wrapper));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(filters => {
      if (typeof filters.unload === 'function') {
        filters.unload();
      }
    });
  },
};

export default collectionFiltersSidebar;

